// How the Voice engines page reads API errors.

import { ApiError } from "../../services/http";

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}

// A write the VOICE_ENGINE_ADMIN_UIDS allowlist refused.
export function isForbidden(e: unknown): boolean {
  return e instanceof ApiError && e.status === 403;
}

// The `errors` list of a structured 422 ({message, errors}), if any.
export function detailErrors(e: unknown): string[] {
  if (!(e instanceof ApiError) || !e.detail || typeof e.detail !== "object") return [];
  const errors = (e.detail as { errors?: unknown }).errors;
  return Array.isArray(errors) ? errors.map(String) : [];
}
